/** RTE-X11.4c — sequential stops editor (position-driven draft sync). */

let editorFlagLogged = false;

/**
 * When unset: OFF in production, ON in development (mirrors save/read defaults).
 * REACT_APP_SEQUENTIAL_STOPS_EDITOR_MODE=true|false
 */
export function isSequentialStopsEditorModeEnabled(): boolean {
  const raw = process.env.REACT_APP_SEQUENTIAL_STOPS_EDITOR_MODE;
  let enabled: boolean;
  if (raw === undefined || raw === '') {
    enabled = process.env.NODE_ENV === 'development';
  } else {
    enabled = String(raw).toLowerCase() === 'true';
  }
  if (process.env.NODE_ENV === 'development' && !editorFlagLogged) {
    editorFlagLogged = true;
    // eslint-disable-next-line no-console
    console.debug('[SequentialStopsEditor] REACT_APP_SEQUENTIAL_STOPS_EDITOR_MODE =', raw, '| enabled =', enabled);
  }
  return enabled;
}

export function isSequentialStopsEditorShadowDebugEnabled(): boolean {
  return process.env.REACT_APP_SEQUENTIAL_STOPS_EDITOR_SHADOW_DEBUG === 'true';
}
